module.exports = __webpack_public_path__ + "static/media/TableSideHole_After.5112c845.jpg";